import React, { Component } from "react";
import Title from "./Title";
// import styles from "./Services.module.css";
import { FaCocktail, FaBicycle, FaBus, FaCoffee } from "react-icons/fa";
import styled from "styled-components";

const SectionServices = styled.section`
  padding: 5rem 0;
  background: #cfcfcf;
  text-align: center;
`;
const ServicesCenter = styled.div`
  width: 90vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 50px;
  span {
    display: inline-block;
    color: #af9a7d;
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
  h6 {
    letter-spacing: 3px;
  }
  p {
    width: 80%;
    margin: 0 auto;
    @media screen and (min-width: 1200px) {
      width: 100%;
    }
  }
  @media screen and (min-width: 1200px) {
    width: 95vw;
    max-width: 1170px;
  }
`;

export default class Services extends Component {
  state = {
    services: [
      {
        icon: <FaCocktail />,
        title: "Free Drinks",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
      {
        icon: <FaBus />,
        title: "Free Bus Tours",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
      {
        icon: <FaBicycle />,
        title: "Endless Bike Riding",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
      {
        icon: <FaCoffee />,
        title: "Complementary Breakfast",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
  };
  render() {
    return (
      <SectionServices>
        <Title title="services" />
        <ServicesCenter>
          {this.state.services.map((item, index) => {
            return (
              <article key={index}>
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              </article>
            );
          })}
        </ServicesCenter>
      </SectionServices>
    );
  }
}
